import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Inject, NgModule } from '@angular/core';
import * as i4 from '@taiga-ui/cdk';
import { TUI_IS_MOBILE, TuiAutoFocusModule } from '@taiga-ui/cdk';
import * as i1 from '@taiga-ui/core';
import { TuiAppearance, TuiButtonModule } from '@taiga-ui/core';
import { TUI_PROMPT_WORDS } from '@taiga-ui/kit/tokens';
import * as i2 from '@tinkoff/ng-polymorpheus';
import { POLYMORPHEUS_CONTEXT, PolymorpheusComponent, PolymorpheusModule } from '@tinkoff/ng-polymorpheus';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i5 from 'rxjs';

// TODO: Rename to tui-confirm in 4.0
class TuiPromptComponent {
    constructor(words$, context, isMobile) {
        this.words$ = words$;
        this.context = context;
        this.isMobile = isMobile;
    }
    get appearance() {
        return this.isMobile ? TuiAppearance.Secondary : TuiAppearance.Flat;
    }
}
TuiPromptComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiPromptComponent, deps: [{ token: TUI_PROMPT_WORDS }, { token: POLYMORPHEUS_CONTEXT }, { token: TUI_IS_MOBILE }], target: i0.ɵɵFactoryTarget.Component });
TuiPromptComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: TuiPromptComponent, selector: "tui-prompt", ngImport: i0, template: "<div\n    *polymorpheusOutlet=\"context.data?.content as text\"\n    class=\"t-content\"\n    [innerHTML]=\"text\"\n></div>\n<div\n    *ngIf=\"words$ | async as words\"\n    class=\"t-buttons\"\n>\n    <button\n        tuiButton\n        type=\"button\"\n        size=\"m\"\n        class=\"t-button\"\n        [appearance]=\"appearance\"\n        (click)=\"context.completeWith(false)\"\n    >\n        {{ context.data?.no || words.no }}\n    </button>\n    <button\n        tuiButton\n        tuiAutoFocus\n        type=\"button\"\n        size=\"m\"\n        class=\"t-button\"\n        (click)=\"context.completeWith(true)\"\n    >\n        {{ context.data?.yes || words.yes }}\n    </button>\n</div>\n", styles: [".t-content:not(:empty){margin-bottom:.875rem}.t-buttons{display:flex;justify-content:flex-end;flex-wrap:wrap-reverse;margin:.375rem -.375rem -.375rem}.t-button{margin:.375rem;white-space:nowrap}:host-context(tui-root._mobile) .t-button{flex:1}\n"], components: [{ type: i1.TuiButtonComponent, selector: "button[tuiButton], button[tuiIconButton], a[tuiButton], a[tuiIconButton]", inputs: ["appearance", "disabled", "icon", "iconRight", "shape", "showLoader", "size"] }], directives: [{ type: i2.PolymorpheusOutletDirective, selector: "[polymorpheusOutlet]", inputs: ["polymorpheusOutlet", "polymorpheusOutletContext"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i4.TuiAutoFocusDirective, selector: "[tuiAutoFocus]", inputs: ["tuiAutoFocus"] }], pipes: { "async": i3.AsyncPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiPromptComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'tui-prompt',
                    templateUrl: './prompt.template.html',
                    styleUrls: ['./prompt.style.less'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: i5.Observable, decorators: [{
                    type: Inject,
                    args: [TUI_PROMPT_WORDS]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [POLYMORPHEUS_CONTEXT]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TUI_IS_MOBILE]
                }] }]; } });
const TUI_PROMPT = new PolymorpheusComponent(TuiPromptComponent);

class TuiPromptModule {
}
TuiPromptModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiPromptModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TuiPromptModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiPromptModule, declarations: [TuiPromptComponent], imports: [CommonModule, PolymorpheusModule, TuiButtonModule, TuiAutoFocusModule], exports: [TuiPromptComponent] });
TuiPromptModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiPromptModule, imports: [[CommonModule, PolymorpheusModule, TuiButtonModule, TuiAutoFocusModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiPromptModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, PolymorpheusModule, TuiButtonModule, TuiAutoFocusModule],
                    declarations: [TuiPromptComponent],
                    exports: [TuiPromptComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_PROMPT, TuiPromptComponent, TuiPromptModule };
